import { VerificationService } from '@sheerid/jslib';

export const sendVerificationIdPostMessage = (verificationService: VerificationService, currentStep: string) => {
    window.parent.postMessage({
        action: `sid-${currentStep}`,
        verificationId: verificationService.verificationResponse.verificationId,
    },                        '*');
};
